const libFableService = require('fable-serviceproviderbase');

class HeadlightPanelsFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { views: any, ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }} */
		this.fable;

		this.serviceType = 'HeadlightPanels';
		this.isPhoneDevice = false; // This will be set later based on the device type
	}

	// TODO: Add Pin state functions (need to adjust the HeadlightPanels view to support this by data state)
	// TODO: Add color options for the custom panel headers
	// TODO: Add a subtitle option for the custom panel headers

	/**
	 * This function is used to check if the HeadlightPanels view is available.
	 * @return {boolean}
	 */
	checkPanels()
	{
		return this.fable.views.hasOwnProperty('HeadlightPanels');
	}

	/**
	 ********** LEFT **********
	*/

	/**
	 * This function is used to toggle the left panel.
	 * @return {void}
	 */
	leftPanelToggle()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the right panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('right', 'close');
		}
		// toggle the left panel
		return this.fable.views.HeadlightPanels.togglePanel('left');
	}

	/**
	 * This function is used to show the left panel.
	 * @return {void}
	 */
	leftPanelShow()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the right panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('right', 'close');
		}
		// toggle the left panel
		return this.fable.views.HeadlightPanels.togglePanel('left', 'open');
	}

	/**
	 * This function is used to show the left custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	leftCustomPanelShow(pTitle)
	{
		this.leftPanelShow();
		this.fable.views.HeadlightPaneCustomLeft.render();
		this.leftPanelSetCustomTitle(pTitle);
	}

	/**
	 * This function is used to hide the left panel.
	 * @return {void}
	 */
	leftPanelHide()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		this.leftPanelResetCustomWidth();
		return this.fable.views.HeadlightPanels.togglePanel('left', 'close');
	}

	/**
	 * This function is used to set the title of the left custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	leftPanelSetCustomTitle(pTitle)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.ContentAssignment.assignContent('#HeadlightPanels-CustomPanel-Left-Header-Title', pTitle || 'Left Panel');
	}

	/**
	 * This function is used to get the address of the left custom panel content.
	 * @return {string}
	 */
	leftPanelCustomContentAddress()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return '#HeadlightPanels-CustomPanel-Left-Content';
	}

	/**
	 * This function is used to toggle the pin state of the left panel.
	 * @param {string} state - The state to set the pin to
	 * @return {void}
	 */
	leftPanelTogglePinState(state)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.togglePanelPinState('left', null, state);
	}

	/**
	 * This function is used to set the width of the left panel.
	 * @param {number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	leftPanelCustomWidth(pPercentage)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.setPanelCustomWidth('left', pPercentage);
	}

	/**
	 * This function is used to reset the width of the left panel.
	 * @return {void}
	 */
	leftPanelResetCustomWidth()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.resetPanelCustomWidth('left');
	}


	/**
	 ********** RIGHT **********
	*/

	/**
	 * This function is used to toggle the right panel.
	 * @return {void}
	 */
	rightPanelToggle()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the left panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('left', 'close');
		}
		// toggle the right panel
		return this.fable.views.HeadlightPanels.togglePanel('right');
	}

	/**
	 * This function is used to show the right panel.
	 * @return {void}
	 */
	rightPanelShow()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the left panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('left', 'close');
		}
		// toggle the right panel
		return this.fable.views.HeadlightPanels.togglePanel('right', 'open');
	}

	/**
	 * This function is used to show the right custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	rightCustomPanelShow(pTitle)
	{
		this.rightPanelShow();
		this.fable.views.HeadlightPaneCustomRight.render();
		this.rightPanelSetCustomTitle(pTitle);
	}

	/**
	 * This function is used to hide the right panel.
	 * @return {void}
	 */
	rightPanelHide()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		this.rightPanelResetCustomWidth();
		return this.fable.views.HeadlightPanels.togglePanel('right', 'close');
	}

	/**
	 * This function is used to set the title of the right custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	rightPanelSetCustomTitle(pTitle)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.ContentAssignment.assignContent('#HeadlightPanels-CustomPanel-Right-Header-Title', pTitle || 'Right Panel');
	}

	/**
	 * This function is used to get the address of the right custom panel content.
	 * @return {string}
	 */
	rightPanelCustomContentAddress()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return '#HeadlightPanels-CustomPanel-Right-Content';
	}

	/**
	 * This function is used to toggle the pin state of the right panel.
	 * @param {string} state - The state to set the pin to
	 * @return {void}
	 */
	rightPanelTogglePinState(state)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.togglePanelPinState('right', null, state);
	}

	/**
	 * This function is used to set the width of the right panel.
	 * @param {number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	rightPanelCustomWidth(pPercentage)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.setPanelCustomWidth('right', pPercentage);
	}

	/**
	 * This function is used to reset the width of the right panel.
	 * @return {void}
	 */
	rightPanelResetCustomWidth()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.resetPanelCustomWidth('right');
	}

	/**
	 ********** Content Highlighting **********
	 */

	/**
	 * This function is used to apply a UI highlight to the given selector or passed content area.
	 * @param {HTMLElement|string} pSelector - The selector or content area to apply the highlight to
	 */
	applyUIHighlight(pSelector)
	{
		// always clear any existing highlights first
		this.clearUIHighlights();

		if (pSelector instanceof HTMLElement)
		{
			pSelector.classList.add('panels-ui-highlight');
			return;
		}
		else if (Array.isArray(pSelector))
		{
			Array.from(document.querySelectorAll(pSelector)).forEach(
				(el) => el.classList.add('panels-ui-highlight'),
			);
		}
		else
		{
			document.querySelector(pSelector).classList.add('panels-ui-highlight');
		}
	}

	/**
	 * This function is used to clear all UI highlights.
	 */
	clearUIHighlights()
	{
		Array.from(document.querySelectorAll('.panels-ui-highlight')).forEach(
			(el) => el.classList.remove('panels-ui-highlight'),
		);
	}

	/**
	 * This function constructs a url for opening academy content.
	 * @param {string} content - The content to open
	 */
	openAcademyContent(content)
	{
		if (content?.includes('headlight.com'))
		{
			this.fable.views.AcademyView.openWithURL(content);
		}
		else if (window.location.href.includes('localhost'))
		{
			this.fable.views.AcademyView.openWithURL( 'https://fieldbook.qa.headlight.com/Assets/templates/documentation/' + content);
		}
		else
		{
			//@ts-ignore
			this.fable.views.AcademyView.openWithURL(_Pict?.HeadlightRestClient?.serverURL?.replace('/1.0/', '/Assets/templates/documentation/') + content);
		}
	}

	/**
	 * Check if the device is a phone based on user agent or screen size.
	 * @return {boolean}
	 */
	checkIfPhoneDevice()
	{
		// Check if the device is a phone based on the user agent or screen size
		const isPhone = /Mobi|Android/i.test(navigator.userAgent) || screen.width < 744;
		this.setIsPhoneDevice(isPhone);
		return isPhone;
	}

	/**
	 * Get if the device is a phone or not.
	 * @return {boolean}
	 */
	getIsPhoneDevice()
	{
		return this.isPhoneDevice;
	}

	/**
	 * Set if the device is a phone or not.
	 * @param {boolean} pIsPhone
	 * @return {boolean}
	 */
	setIsPhoneDevice(pIsPhone)
	{
		this.isPhoneDevice = pIsPhone;
		this.log.info(`HeadlightPanelsFableService: Device set to ${pIsPhone ? 'phone' : 'desktop'}`);
		return this.isPhoneDevice;
	}
}

module.exports = HeadlightPanelsFableService;
module.exports.default_configuration = {};
